
import React, { Component, PropTypes } from 'react';

class Option extends Component {

  render () {

    return (
      <option {...this.props} />
    );
  }
}

export default Option;




// WEBPACK FOOTER //
// ./components/Select/Option.jsx